export default __webpack_public_path__ + "static/media/OGApharmacy.9aae08b3.png";